Hop.defineModule('language-selector', (domRoot) => {
    function init() {
        registerEventListeners();
    }

    function registerEventListeners() {
        registerLanguageSelectorEventListener();
    }

    function registerLanguageSelectorEventListener() {
        const item = domRoot.querySelector('#footer-language-selector');
        item.addEventListener('click', handleLanguageSelectorClick);
    }

    function handleLanguageSelectorClick() {
        $('#languageSelectorModal').modal('show');
    }

    init();

    return function destroy() {
        const item = domRoot.querySelector('#footer-language-selector');
        item.removeEventListener('click', handleLanguageSelectorClick);
    };
});
